import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { StripeCardElementOptions, StripeElementsOptions } from '@stripe/stripe-js';
import { Auth } from 'aws-amplify';
import { StripeCardComponent, StripeService } from 'ngx-stripe';
import { environment } from 'src/environments/environment';
import { CacheService } from '../services/cache.service';
import { ConstantsService } from "../services/constants.service";
import { GetPaymentService } from '../services/get-payment.service';
import { SharedMixpanelService } from '../services/shared-mixpanel.service';
import { SpinnerService } from '../services/spinner.service';


@Component({
  selector: 'app-stripe-payment',
  templateUrl: './stripe-payment.component.html',
  styleUrls: ['./stripe-payment.component.scss']
})
export class StripePaymentComponent implements OnInit {
  public getDetails: any = UntypedFormGroup;
  public amount: number;
  public getAmount = false;
  public popUp = true;
  public sendTipsPop = false;
  public payment = false;
  public stripeTest: UntypedFormGroup;
  public cardError = "";
  public creatorDetails;
  public userName;
  public userEmail;
  public creatorName;
  public placeholder;
  public paymentProcessing; false
  @ViewChild(StripeCardComponent) card: StripeCardComponent;

  cardOptions: StripeCardElementOptions = {
    style: {
      base: {
        iconColor: '#265D6E',
        color: '#265D6E',
        fontWeight: 'normal',
        fontFamily: '"Graphik"',
        backgroundColor: "#ffffff",
        padding: '20px',
        fontSize: '12px',
        '::placeholder': {
          color: '#C4C4C4',
          fontWeight: 'normal',
          fontFamily: '"Graphik"',
          fontSize: '12px',
        }
      }
    }
  };
  elementsOptions: StripeElementsOptions = {
    locale: 'en'
  };

  constructor(public constants: ConstantsService,
    private stripeService: StripeService,
    private fb: UntypedFormBuilder,
    public dialog: MatDialog,
    private authenticate: CacheService,
    private spinner: SpinnerService,
    private initPayment: GetPaymentService,
    private mixpanel: SharedMixpanelService
  ) {
  }

  ngOnInit(): void {
    this.creatorDetails = this.authenticate.startpayment()
    this.creatorName = this.creatorDetails.creatorName
    this.placeholder = `Tell ${this.creatorName} how this window helped you`
    this.authcall()
    this.getDetails = new UntypedFormGroup({
      'textarea': new UntypedFormControl(null),
      'name': new UntypedFormControl("")
    });

  }
  public async authcall() {
    this.authenticate.getAuthUser()
      .then(data => {
        let { email, login } = data
        if (login) {
          this.userEmail = email
        }
        else {
          this.userEmail = 'unauthorised user'
        }
        this.spinner.hide()
      })
      .catch(error => {
        this.spinner.hide()
      })
  }
  sendTips() {
    this.getAmount = false;
    this.sendTipsPop = true;
    this.popUp = false;
    this.payment = false;
  }
  doPayment() {
    this.sendTipsPop = false;
    this.popUp = false;
    this.payment = true;
  }
  clickEventHandler(value) {
    this.getAmount = true;
    this.amount = value;
  }
  onCickMore(event) {
    this.amount = event.target.value;
    if (event.target.value.length !== 0) {
      this.getAmount = true;
    }
    else if (event.target.value.length === 0) {
      this.getAmount = false;
    }
  }

  async onSubmit() {
    this.paymentProcessing = true
    let userName
    if (this.getDetails.value.name.length === 0) {
      userName = "A WindowSwapper"
    }
    else {
      userName = this.getDetails.value.name
    }
    await this.stripeService.createToken(this.card.element).subscribe(async (result) => {
      if (result.token) {
        let { id } = result.token
        let data = {
          messageOfUser: this.getDetails.value.textarea,
          usersName: userName,
          amountPaid: this.amount,
          creatorsEmail: this.creatorDetails.creatorsEmail,
          accountId: this.creatorDetails.accountId,
          paymentId: "payment",
          cardToken: id,
          usersEmail: this.userEmail,
        }
        this.mixpanel.actions.track("Tip", {
          "Amount paid": this.amount,
          "Name": userName,
          "Email": this.userEmail,
          "Amount send to": data.creatorsEmail,
        });
        this.mixpanel.actions.alias(userName)
        await this.initPayment.createPayment(data)
          .then((data) => {
            this.payment = true;
            this.getDetails.reset();
            this.sendTipsPop = false;
            this.popUp = false;
            this.cardError = ""
            this.paymentProcessing = false
          })
          .catch((error) => {
            this.cardError = error.error.msg;
            this.paymentProcessing = false
          })
      }
      else {
        this.cardError = result.error.message;
        this.paymentProcessing = false
      }
    });
  }
  onClose() {
    this.dialog.closeAll()
  }
  closepopup() {
    this.dialog.closeAll();
  }
  goBack() {
    this.popUp = true;
    this.sendTipsPop = this.false;
    this.payment = this.false;
  }
}







